import Button from "./Button";

export function LogoutButton({ isLoading, onClick }) {
  return (
    <Button
      type="destructive"
      label="Logout"
      size="small"
      disabled={isLoading}
      loading={isLoading}
      stretch={false}
      center={true}
      onClick={onClick}
    />
  );
}
